/* eslint-disable no-unused-vars */
import React, { useMemo } from 'react'

import { AuthUserNode, MeNode } from '@/apollo/graphql'
import { OptionSelector } from '@/components/index'
import { Maybe } from '@/types'
import { useSelect } from './useSelect'

interface Props {
  isEditing?: boolean
  initial?: Maybe<Partial<AuthUserNode | MeNode>>
  [x: string]: any
}

const UserSelector: React.FC<Props> = ({ isEditing, initial, ...rest }) => {
  const { userOptions, loading, pageInfo, onFetchMore, onSearch } = useSelect({
    initial,
  })

  const emptyValue = useMemo(() => (isEditing ? '' : '...'), [isEditing])

  return (
    <OptionSelector
      {...rest}
      isSearchable
      isAsync
      name={rest.name}
      menuPlacement="top"
      options={userOptions}
      optionsLoading={loading}
      emptyValue={emptyValue}
      disabled={!Boolean(isEditing)}
      label={rest.label}
      fetchMoreStatus={pageInfo.fetchMoreStatus}
      onFetchMore={onFetchMore}
      onSearch={onSearch}
    />
  )
}

export default UserSelector
